import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=abe105c2&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=ts"
export * from "./ClientInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe105c2",
  null
  
)

export default component.exports